export default function (element, data) {
    window.addEventListener("open-popup-filter", function (e) {
        element.classList.add("open");
        document.body.classList.add("no-scroll");
    });
    window.addEventListener("close-popup-filter", function () {
        element.classList.remove("open");
        document.body.classList.remove('no-scroll');
    });
}
